// shared/components/AnimatedRoute.jsx
import React from 'react';
import { motion } from 'framer-motion';

const AnimatedRoute = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.15 }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedRoute;